import { Button, Flex, Form } from "antd";
import { useTranslation } from "react-i18next";
import {
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../components";
import { pushGtag } from "../../../../plugins/utils";
import { InputRequired } from "../../../../validations/validations";
import { OtherFilterProps } from "../../data";

const OtherFilter = ({
  form,
  coachInfo,
  params,
  setOpen,
  studentLimit,
  setStudentLimit,
  showHalfDaySelector,
  setShowHalfDaySelector,
}: OtherFilterProps) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    pushGtag({
      event: "book_coach_cancel",
    });

    setOpen(false);
  };

  return (
    <>
      <Form.Item
        name={"skill_type"}
        label={t("normal.skill.title")}
        rules={[InputRequired(t, "normal.skill.title")]}
      >
        <SkillSelector form={form} skillCode={coachInfo?.skill_codes} />
      </Form.Item>
      <Form.Item
        name={"locations"}
        label={t("home.searchbar.resort.title")}
        rules={[InputRequired(t, "home.searchbar.resort.title")]}
      >
        <ResortDropdown
          form={form}
          skiResortCode={coachInfo?.ski_resort_codes}
          setShowHalfDaySelector={setShowHalfDaySelector}
          setStudentLimit={setStudentLimit}
        />
      </Form.Item>
      {showHalfDaySelector && (
        <Form.Item
          name={"session_type"}
          label={t("normal.sessionType")}
          rules={[InputRequired(t, "normal.sessionType")]}
        >
          <SessionTypeSelector form={form} />
        </Form.Item>
      )}
      <Form.Item
        name={"count"}
        label={t("normal.count.title")}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (
                Number(getFieldValue("adults")) === 0 &&
                Number(getFieldValue("kids")) === 0
              )
                return Promise.reject(
                  new Error(
                    t("form.required", { name: t("normal.count.title") })
                  )
                );
              return Promise.resolve();
            },
          }),
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (
                Number(getFieldValue("adults")) +
                  Number(getFieldValue("kids")) >
                studentLimit
              ) {
                return Promise.reject(
                  new Error(
                    t("home.filter.count.error", { limit: studentLimit })
                  )
                );
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <CountDropdown
          form={form}
          params={params}
          studentLimit={studentLimit}
        />
      </Form.Item>
      <Form.Item hidden name={"adults"} initialValue={0} />
      <Form.Item hidden name={"kids"} initialValue={0} />
      <Flex gap={8} justify="flex-end">
        <Button onClick={handleCancel}>{t("normal.cancel")}</Button>
        <Button type="primary" htmlType="submit">
          {t("normal.nextstep")}
        </Button>
      </Flex>
    </>
  );
};

export default OtherFilter;
